import React from 'react';
import classNames from 'classnames';
import { NodeRowProps } from '../../types';
import { Checkbox } from 'ncoded-component-library';
import useNodeInfo from '../../hooks/useNodeInfo';
import useNodeVariables from '../../hooks/useNodeVariables';
import MymeTypeIcon from 'router/subrouters/DataRoom/components/DataRoomDocumentsRouter/components/MymeTypeIcon';
import DataRoomNodeTagAndVersion from 'components/DataRoomNodeTagAndVersion';
import { getNodeMimeType } from 'utils';

import './FileNodeRow.styles.scss';

const FileNodeRow: React.FC<NodeRowProps> = (props) => {
  const { className, node, checkedFilesIds, onChange, checkIfNodeIsDisabled } =
    props;

  const classes = classNames('file-node-row', className);

  const createInfoData = useNodeInfo();

  const { checked, disabled, nodeClass, currState } = useNodeVariables({
    node,
    checkedFilesIds,
    checkIfNodeIsDisabled,
  });

  return (
    <div className={classes}>
      <Checkbox
        key={currState}
        checked={checked}
        className={nodeClass}
        disabled={disabled}
        onChange={() => onChange(node?._id, currState)}
        label={
          <div className="file-access-selector__node-info">
            <MymeTypeIcon mimeType={getNodeMimeType(node)} />
            <span>
              <p className="name">
                <span>{node.name}</span>
                <DataRoomNodeTagAndVersion
                  tag={node.tag}
                  version={node.version}
                />
              </p>
              {createInfoData(node)}
            </span>
          </div>
        }
      />
    </div>
  );
};

export default FileNodeRow;
